export default __webpack_public_path__ + "static/media/mute-audio-on.abc18459.svg";